interface CwbNewsletterPersonalInfo {
  email: string
  firstname: string
  lastname: string
  salutation: string
}

export const useCwbNewsletterSubscribe = () => {
  const config = useRuntimeConfig()

  const subscribe = async (personalInfo: CwbNewsletterPersonalInfo) => {
    const currentDate = new Date().toISOString().split('T')[0]

    const payload = {
      institutionId: 'cwb',
      email: personalInfo.email,
      attributes: {
        VORNAME: personalInfo.firstname,
        NACHNAME: personalInfo.lastname,
        ANREDE: parseInt(personalInfo.salutation),
        OPT_IN_DATUM_ANMELDUNG_VIA_FORMULAR: currentDate,
        OPT_IN: false,
        DOI_DATRUM_ANMELDUNG_VIA_NEWSLETTER: currentDate,
      },
      listIds: [parseInt(String(config.public.cwbNewsletterListId)) || 109],
      updateEnabled: true,
    }

    const result = await fetch(`${config.public.frontendBaseUrl}/api/brevo/event-registration`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })

    const data = await result.json()

    if (!data) {
      console.log('Something went wrong with newsletter subscription!')
    }

    return data
  }

  return { subscribe }
}
